import { PRODUCT_BUSINESS_UNIT_KINDS_MAP } from 'pages/AuditLogs/constants';
import { FlatOption, ProductSelection } from 'pages/AuditLogs/types';

const filterOptionsByProduct = (options: FlatOption[], productSelection: ProductSelection) => {
  if (!productSelection) {
    return options;
  }

  const validKinds = PRODUCT_BUSINESS_UNIT_KINDS_MAP[productSelection];
  if (!validKinds) {
    return options;
  }

  return options.filter(option => validKinds.has(option.kind));
};

export default filterOptionsByProduct;
